import * as e from "react";
function n(t) {
  var r = e.useRef();
  r.current = t;
  var a = e.useCallback(function() {
    return r.current.apply(r, arguments);
  }, []);
  return a;
}
export {
  n as default
};
//# sourceMappingURL=useRefFunc.mjs.map
